<div class="tw-flex tw-flex-col tw-gap-4">
  <!-- Sections: Monthly / Yearly -->
  @for (section of sections(); track section.id) {
    <section class="tw-flex tw-flex-col tw-gap-3 tw-px-3">
      <div class="tw-flex tw-flex-wrap tw-gap-3 tw-items-center">
        <!-- Title + Limited Time Offer badge — grouped as a real row on mobile (badge
             vertically centers against the title even when it wraps to 2 lines);
             `min-md:tw-contents` makes this wrapper invisible on desktop so the original
             per-child order/basis classes below still drive the desktop layout unchanged. -->
        <div class="md:tw-flex md:tw-w-full md:tw-items-center md:tw-gap-3 min-md:tw-contents">
          <span
            class="tw-order-1 md:tw-basis-full min-md:tw-basis-auto tw-text-color-text-default tw-font-semibold tw-text-sm md:tw-text-[13px] md:tw-flex-1 md:tw-min-w-0"
          >
            {{ "aussieBankSubscription" | i18n }}
          </span>
          <div
            class="tw-order-2 md:tw-order-4 tw-ml-auto md:tw-ml-0 md:tw-flex-shrink-0 tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-[28px] tw-min-w-[60px] tw-px-2 tw-bg-color-status-warning-bg tw-rounded-full"
          >
            <span
              class="tw-text-[13px] tw-text-color-status-warning-text tw-font-medium tw-whitespace-nowrap"
            >
              {{ "limitedTimeOffer" | i18n }}
            </span>
          </div>
        </div>

        <div class="tw-order-3 min-md:tw-basis-full md:tw-hidden tw-h-0"></div>

        <!-- x3/Months-available + progress bar — same grouping trick as above, so the
             progress bar vertically centers against the 2-line x3/Months block on mobile. -->
        <div class="md:tw-flex md:tw-w-full md:tw-items-center md:tw-gap-3 min-md:tw-contents">
          <div
            class="tw-order-4 md:tw-order-2 min-md:tw-basis-auto md:tw-basis-auto min-md:tw-self-end md:tw-mb-6 tw-flex tw-flex-col tw-items-start tw-gap-1 md:tw-gap-2"
          >
            <div
              class="tw-w-12 tw-h-12 tw-rounded-xl tw-bg-gradient-teal tw-shadow-monthly-square tw-flex tw-items-center tw-justify-center md:tw-flex-shrink-0"
            >
              <span class="tw-text-color-text-on-dark tw-text-sm">x</span>
              <span class="tw-text-color-text-on-dark tw-font-semibold tw-text-3xl">
                {{ section.currentPoints / 1000 | number: "1.0-0" }}
              </span>
            </div>
            <div
              class="tw-font-normal tw-text-color-text-default tw-text-sm md:tw-leading-tight md:tw-text-[12px] md:tw-whitespace-nowrap"
            >
              {{ "monthsAvailable" | i18n }}
            </div>
          </div>

          <!-- Progress bar -->
          <div
            class="tw-order-5 md:tw-basis-0 min-md:tw-basis-0 tw-flex-1 tw-flex min-md:tw-justify-end md:tw-justify-center min-md:tw-self-end"
          >
            <div class="tw-relative tw-w-full md:tw-max-w-sm tw-h-[35px]">
              <!-- Current Points Indicator -->
              <div
                class="tw-absolute tw-bottom-full tw-mb-1 tw--translate-x-1/2"
                [ngStyle]="{ left: getPointsPosition(section.currentPoints) + '%' }"
              >
                <div class="tw-flex tw-flex-col tw-items-center">
                  <span
                    class="tw-font-D-DIN-PRO tw-tabular-nums tw-text-[16px] tw-font-semibold tw-text-color-text-default tw-whitespace-nowrap"
                  >
                    {{ section.currentPoints | number }} CrG
                  </span>
                </div>
              </div>

              <!-- Track -->
              <div class="tw-h-3 tw-rounded-xl tw-bg-color-surface-input tw-shadow-progress-track">
                <div
                  class="tw-h-full tw-rounded-xl tw-bg-gradient-progress"
                  [ngStyle]="{ width: getPointsPosition(section.currentPoints) + '%' }"
                ></div>
              </div>

              <!-- Range labels: left and right -->
              <div class="tw-flex tw-justify-between tw-mt-2 tw-px-1">
                <span
                  class="tw-font-D-DIN-PRO tw-tabular-nums tw-text-[14px] tw-text-color-text-tertiary"
                >
                  {{ rangeStart() | number }} CrG
                </span>
                <span
                  class="tw-font-D-DIN-PRO tw-tabular-nums tw-text-[14px] tw-text-color-text-tertiary"
                >
                  {{ rangeEnd() | number }} CrG
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Bottom row: GV icon + details + Redeem -->
      <div
        class="tw-flex tw-flex-nowrap tw-items-center tw-gap-x-4 tw-shadow-card-item tw-rounded-2xl tw-p-4 sm:tw-px-2"
      >
        <div class="tw-flex tw-items-center tw-min-w-0">
          <div
            class="tw-w-9 tw-h-9 tw-px-2 tw-rounded-xl tw-flex tw-items-center tw-justify-center tw-bg-gradient-giftbg tw-flex-shrink-0"
          >
            <icon [size]="6" [name]="'gift'"></icon>
          </div>

          <!-- On phones the button below sizes to its label, which leaves this room for the
               whole name (one word per line), so it isn't capped at 90px there. -->
          <div class="tw-ml-1 tw-min-w-0">
            <span
              class="tw-block tw-truncate md:tw-whitespace-normal md:tw-max-w-[90px] sm:tw-max-w-none tw-font-semibold tw-text-color-text-default md:tw-text-[13px]"
            >
              {{ "monthlySubscription" | i18n }}
            </span>
          </div>
        </div>

        <button
          type="button"
          (click)="confirmRedemption()"
          class="tw-shadow-button-bg tw-w-[175px] sm:tw-w-auto tw-flex-shrink-0 tw-rounded-xl tw-py-2.5 tw-px-4 md:tw-px-3 sm:tw-px-6 tw-bg-gradient-teal tw-text-center tw-text-color-text-on-action tw-font-semibold tw-text-sm tw-ml-auto"
        >
          <span class="tw-uppercase">{{ "redeem" | i18n }}</span>
        </button>
      </div>
    </section>
  }
</div>

<ng-template #footerTemplate>
  <!-- Full-bleed: cancels the dialog-wrapper footer slot's own tw-px-8/tw-rounded-b-3xl/
       tw-bg-color-surface-page so this card-colored footer covers it edge-to-edge and
       corner-to-corner, instead of leaving surface-page gutters showing through around a
       narrower, square-cornered child. -->
  <div class="tw--mx-8 tw-rounded-b-3xl tw-bg-color-surface-card">
    <div class="tw-w-full tw-max-w-[502px] tw-mx-auto tw-flex tw-flex-col tw-px-8">
      <div class="tw-flex tw-flex-row sm:tw-flex-col tw-gap-4 tw-py-5 tw-items-center">
        <button
          type="button"
          (click)="cancel()"
          class="sm:tw-w-[calc(100%+32px)] tw-w-[196px] tw-h-[60px] tw-rounded-full tw-bg-color-surface-card tw-shadow-list tw-font-medium tw-text-color-status-error-text tw-text-[20px]"
        >
          {{ "cancel" | i18n }}
        </button>
        <app-gloss-button
          class="tw-w-[300px] sm:tw-w-[calc(100%+32px)]"
          [options]="saveButtonOptions"
        ></app-gloss-button>
      </div>
    </div>
  </div>
</ng-template>
